// ──────────────────────────────────────────────────────
// Phase 9R — Trust-chip handler shared by ChatDrawer + /m/q
//
// The backend `authenticity_query` short-circuit emits chips like
// "🔒 عرض شهادة الأصالة" / "عرض شهادات الاعتماد" / "عرض وثائق التوريد
// المتاحة" / "عرض شهادات التوريد المتاحة" alongside its conservative
// answer. Without a client-side hook, tapping one of those chips would
// send the chip text back as a chat message and re-trigger the same
// authenticity_query turn — a closed loop. This helper lets each chat
// surface intercept the click and open the TrustModal directly.
//
// Pure: no React, no DOM, no I/O.
// ──────────────────────────────────────────────────────

/** Set of customer-visible chip labels that should open TrustModal
 *  rather than send a new chat message. Add new entries here as new
 *  trust chips are introduced server-side; both ChatDrawer and the
 *  mobile /m/q page will pick them up automatically. */
export const TRUST_CHIP_LABELS: ReadonlySet<string> = new Set([
    '🔒 عرض شهادة الأصالة',
    'عرض شهادات الاعتماد',
    'عرض وثائق التوريد المتاحة',
    'عرض شهادات التوريد المتاحة',
]);

/** True when the chip text matches a known trust-chip label after a
 *  conservative trim. Compared exactly (case + emoji + RTL marks all
 *  matter) — the backend produces these strings literally so an exact
 *  set match is the right contract. */
export function isTrustChipText(text: string | null | undefined): boolean {
    if (typeof text !== 'string') return false;
    return TRUST_CHIP_LABELS.has(text.trim());
}
